"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.format = exports.defaultCurrency = void 0;

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

// import
// definition
var defaultCurrency = 'TWD';
exports.defaultCurrency = defaultCurrency;
var CURRENCY_CONFIG = {
  TWD: {
    symbol: 'NT$',
    noCountrySymbol: '$',
    precision: 0
  },
  CNY: {
    symbol: 'RMB￥',
    noCountrySymbol: '￥',
    precision: 2
  },
  USD: {
    symbol: 'US$',
    noCountrySymbol: '$',
    precision: 2
  },
  JPY: {
    symbol: 'JPY¥',
    noCountrySymbol: '¥',
    precision: 0
  },
  EUR: {
    symbol: '€',
    noCountrySymbol: '€',
    precision: 2
  },
  VND: {
    symbol: '₫',
    noCountrySymbol: '₫',
    precision: 0
  },
  KRW: {
    symbol: '₩',
    noCountrySymbol: '₩',
    precision: 0
  },
  HKD: {
    symbol: 'HK$',
    noCountrySymbol: '$',
    precision: 1
  },
  MYR: {
    symbol: 'RM',
    noCountrySymbol: 'RM',
    precision: 2
  },
  SGD: {
    symbol: 'S$',
    noCountrySymbol: '$',
    precision: 2
  }
};

var format = function format(currency, price, noSymbol, noCountrySymbol, noSpace) {
  var config = CURRENCY_CONFIG[currency] || {
    symbol: '',
    noCountrySymbol: '',
    precision: 0
  };
  var symbol = '';

  if (!noSymbol) {
    symbol = noCountrySymbol ? config.noCountrySymbol : config.symbol;
  }

  var formattedPrice = price.toFixed(config.precision).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return [symbol, formattedPrice].filter(Boolean).join(noSpace ? '' : ' ');
};

exports.format = format;

var _default = /*#__PURE__*/_react["default"].createContext({
  c: function c(price, noSymbol, noCountrySymbol, noSpace) {
    return format('TWD', price, noSymbol, noCountrySymbol, noSpace);
  },
  setCurrency: _emptyFunction["default"],
  currency: defaultCurrency,
  currencySymbol: 'NT$'
});

exports["default"] = _default;